






















































import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";

import {
    pageDataType,
    componentDataType,
    ProductPageDataType
} from "../types";
import {
    HOST,
    API_URL
} from "../global";
import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    FETCH_PRODUCT_DATA
} from "../store/actions.names";
import axios from "axios";
import {
    capitalizeFirstLetter
} from "../utils/common";
@Component({
    name: "ProductHighlights"
})
export default class ProductHighlights extends Vue {
    @Prop() public compData!: string | null;
    // @Getter("productData") public productData!: ProductPageDataType[];
    // @Prop() public pageData!: pageDataType;
    // @Getter("pageType") public pageType!: string | null;
    @Action(FETCH_PRODUCT_DATA) public fetchData: any;
    // @Mutation(SET_PRODUCT_CURRENT_PAGE) public[SET_PRODUCT_CURRENT_PAGE]: any;
    genderOptions = ["men", "women", "kids"];
    public HOST: string = HOST;
    gender: string = "men";
    accordionIndex = 0;
    //modalIndex = 0;
    isActive: boolean = false;
    isDropped: boolean = false;
    isDropping: boolean = false;
    isAccordion: boolean = false;
    isAdd: boolean = false;
    productCategories: any = [];
    capitalizeFirstLetter: any = capitalizeFirstLetter;

    @Watch("gender", {
        immediate: true
    })
    handleGenderChange(val: string, oldVal: string) {
        if (val != oldVal) {
            this.fetchData(val)
                .then((data: any) => {
                    this.productCategories = data;
                    if (data.length > 0) {
                        this.accordionIndex = 0;
                    } else {
                        this.accordionIndex = -1;
                    }
                });
        }
    }

    // setActive(index: any) {
    //     (this as any).active = index;
    // }
    // activeNote() {
    //     return (this as any).notes[(this as any).active];
    // }

    // public dropQrt() {
    //     this.isDropped = !this.isDropped;
    //     this.isAdd = !this.isAdd;
    // }

    // public dropYear() {
    //     this.isDropping = !this.isDropping;
    //     this.isActive = !this.isActive;
    // }
    // public qfaccordion() {
    //     this.isAccordion = !this.isAccordion;
    //     this.isActive = !this.isActive;
    // }
}
